module.exports = __webpack_public_path__ + "static/media/Sec-1_HomePage_EN.170d3ee2.png";